if (!customElements.get("country-selector")) {
    customElements.define(
      "country-selector",
      class CountrySelector extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
            this.button = this.querySelector(".country-selector__button");
            this.dropdown = this.querySelector(".country-selector__dropdown");

            this.onKeyDown = this.onKeyDown.bind(this);
            this.addEventListener("keydown", this.onKeyDown);

            this.button.addEventListener("click", () => {
                this.setExpanded(!this.isExpanded());
            });

            window.addEventListener("click", (e) => {
                if (!this.contains(e.target) && !this.button.contains(e.target)) {
                    this.setExpanded(false);
                }
            });
        }
  
        disconnectedCallback() {
            this.removeEventListener("keydown", this.onKeyDown);
        }

        isExpanded() {
            return this.dropdown.classList.contains(
                "country-selector__dropdown--active",
            );
        }

        /**
         * Single point at which the open/closed state changes, so the exposed
         * aria-expanded can never drift from the classes that do the showing
         * and hiding (WCAG 4.1.2).
         */
        setExpanded(expanded) {
            this.button.classList.toggle(
                "country-selector__button--active",
                expanded,
            );
            this.dropdown.classList.toggle(
                "country-selector__dropdown--active",
                expanded,
            );
            this.button.setAttribute("aria-expanded", expanded ? "true" : "false");
        }

        onKeyDown(event) {
            if (event.key !== "Escape" && event.keyCode !== 27) return;
            if (!this.isExpanded()) return;

            this.setExpanded(false);
            // Focus would otherwise be stranded on a link that just became
            // visibility:hidden, so hand it back to the control that opened it.
            this.button.focus();
        }
      },
    );
  }
  

//   NL,Netherlands ($),https://lattledutch.com/pages/reviews
// DE,Germany ($),https://lattledutch.com/pages/reviews
// US,United States ($),https://lattledutch.com/pages/reviews
// GB,United Kingdom ($),https://lattledutch.com/pages/reviews
// EU, Europe ($),https://lattledutch.com/pages/reviews